import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from 'src/app/core/api/product/product.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ProductDTO } from 'src/app/shared/models/dtos/responses/product-dto/product-dto';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})

/**
 *
 */
export class ProductListComponent implements OnInit {
  page = 0;
  pageSize = 10;
  admins = [] as any[];
  loading = false;
  pulling = false;
  feedItems: any[] = [];
  mockedProducts: any[] = ProductDTO.MockProducts();
  labels = {
    productName: 'product-name',
    productHeaders: 'product-header',
    productRewards: 'product-rewards',
    error: 'unexpected-error',
  };
  call?: Subscription;
  _familyId?: string;

  /**
   * @constructor
   */
  constructor(
    private productService: ProductService,
    private translationService: TranslationService,
    private snackBarService: SnackBarService,
    private router: Router
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.translationService.translateObject(this.labels);
    this.getProducts();
  }

  /**
   * set family id and update family list
   * @param {string} value
   */
  @Input() set familyId(value: string) {
    if (value === 'all') {
      this._familyId = undefined;
    } else {
      this._familyId = value;
    }
    this.getProducts();
  }

  /**
   * Get products
   */
  getProducts() {
    this.loading = true;
    if (this.call) {
      this.call.unsubscribe();
    }
    this.page = 0;
    this.call = this.productService
      .getProductList(this.page, this.pageSize, this._familyId)
      .subscribe({
        next: (products) => {
          this.feedItems = products;
        },
        error: () => {
          this.loading = false;
          this.snackBarService.error(this.labels.error);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  /**
   * Fetch more admins and append to list
   */
  async pullProducts() {
    if (this.pulling) {
      return;
    }

    this.pulling = true;
    this.page++;

    this.productService
      .getProductList(this.page, this.pageSize, this._familyId)
      .subscribe((products) => {
        if (products.length > 0) {
          this.feedItems?.push(...products);
        } else {
          this.page = this.page - 1;
        }
      })
      .add(() => {
        this.pulling = false;
      });
  }

  /**
   * Navigates to the product edit page and closes the dialog.
   * @param {ProductDTO} productData
   */
  goToProductEdit(productData: ProductDTO) {
    this.router.navigate([RoutesKeys.PRODUCT_DETAIL, productData.id], {
      state: { productData: productData },
    });
  }
}
